// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type InfoCircle48FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const InfoCircle48Filled: FC<InfoCircle48FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path
                d="M24 42c9.941 0 18-8.059 18-18S33.941 6 24 6 6 14.059 6 24s8.059 18 18 18Zm0-23.7c.466 0 .858-.153 1.175-.46.317-.307.475-.687.475-1.14 0-.482-.158-.885-.474-1.211A1.571 1.571 0 0 0 24 15c-.467 0-.86.163-1.176.489-.317.326-.475.73-.475 1.211 0 .453.158.833.474 1.14.316.307.708.46 1.175.46ZM22.65 34h3V22h-3v12Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default InfoCircle48Filled;
